import { Carousel } from 'react-bootstrap'

import { getImageUrl } from '../../utils'

const CampaignBanner = ({ images }) => {
  return (
    <div className="campaignBanner">
      <Carousel
        controls={false}
        indicators={images?.length > 1}
        interval={5000}
      >
        {images?.map((item) => (
          <Carousel.Item key={'carousel' + item?.id}>
            <img
              src={getImageUrl(item)}
              alt={item.alternativeText}
              className="w-[100%]"
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  )
}

export default CampaignBanner
